module.exports = "/public/assets/img/down-arrow.png";